import React, { useState, useRef, useEffect } from 'react';
import Input from '../input/index.jsx';
import Option from './option.jsx';

const Datalist = ({
  onSelect,
  items = [],
  customOptionsContainerStyle = {},
  defaultValues = [],
  highlightOnHover = true,
  withImage = false,
  keepOpen = false,
  maxSelectedItems,
  maxSelectedItemsCallback,
}) => {
  const [internalValue, setInternalValue] = useState(defaultValues);
  const [internalStates, setInternalStates] = useState({ value: '', items });

  const [isDatalistOpen, setIsDatalistOpen] = useState(keepOpen);
  const ref = useRef(null);

  useEffect(() => {
    const handleBlur = (e) => {
      if (!ref?.current?.contains(e.target) && !keepOpen) {
        setIsDatalistOpen(false);
      }
    };
    window.addEventListener('click', handleBlur);
    return () => window.removeEventListener('click', handleBlur);
  }, []);

  useEffect(() => {
    onSelect(internalValue);
  }, [internalValue]);

  const onChange = ({ target: { value } }) => {
    const filteredArray = items.filter( item => item.label.toUpperCase().includes(value.toUpperCase()));
    setInternalStates({ value, items: filteredArray });
  };

  const onFocus = () => {
    setIsDatalistOpen(true);
  };

  const onOptionSelect = (selected) => {
    const { id } = selected;
    const indexToRemove = internalValue.findIndex( v => v.id === id);
    if (indexToRemove >= 0) {
      setInternalValue([...internalValue.slice(0, indexToRemove), ...internalValue.slice(indexToRemove + 1)]);
    } else if (internalValue.length >= maxSelectedItems) {
      maxSelectedItemsCallback(internalValue.length);
    } else {
      setInternalValue([...internalValue, selected]);
    }
  };

  return (
    <div ref={ref}>
      <Input
        onChange={onChange}
        onFocus={onFocus}
        value={internalStates.value}
      />
      {isDatalistOpen && (
        <div style={{ ...styles.container, ...customOptionsContainerStyle }}>
          {internalStates.items.map( ({ id, label, image }) => (
            <Option
              key={id}
              id={id}
              label={label}
              image={image}
              onOptionSelect={onOptionSelect}
              highlightOnHover={highlightOnHover}
              isChecked={internalValue.some( v => v.id === id)}
              withImage={withImage}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    position: 'absolute',
    width: 400,
    zIndex: 4,
    marginTop: -15,
    maxHeight: 300,
    backgroundColor: '#fff',
    border: '1px black solid',
    overflowY: 'scroll',
  },
};
export default Datalist;
